'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ALIGN_OPTIONS = exports.ALIGN_OPTIONS = {
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};

var ALIGN_SELF_OPTIONS = exports.ALIGN_SELF_OPTIONS = {
  auto: '',
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};

var DIRECTION_OPTIONS = exports.DIRECTION_OPTIONS = {
  column: 'column',
  row: '',
  'column-reverse': 'column-reverse',
  'row-reverse': 'row-reverse'
};

var JUSTIFY_OPTIONS = exports.JUSTIFY_OPTIONS = {
  around: 'space-around',
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start'
};

var WRAP_OPTIONS = exports.WRAP_OPTIONS = {
  nowrap: '',
  wrap: 'wrap'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/layout/FlexConstants.js
// module id = 1157
// module chunks = 2 3